module.exports = __webpack_public_path__ + "img/illusThrones3.7586bdc7.jpg";